import { defineElement, html, TemplateElement } from '@webtides/element-js';
import '../../../../src/components/@e-banking/components/e-banking-button-bar/e-banking-button-bar.js';
import { mapNodes } from '@/mgnl/utils/magnolia.js';
import { getLinkAttributes } from '@/services/content-service.js';

class EditableButonBar extends TemplateElement {
    properties() {
        return {
            content: {},
        };
    }
    injectProperties() {
        return { environment: null };
    }

    get links() {
        return mapNodes(this.content.links).map((link) => getLinkAttributes({ link, environment: this.environment }));
    }

    events() {
        return {
            this: {
                click: (e) => {
                    const buttons = this.$refs.buttonBar?.$refs?.buttons ?? [];
                    const path = typeof e.composedPath === 'function' ? e.composedPath() : [];
                    const clickedButton = path.find((node) => buttons.includes(node));
                    const index = clickedButton ? buttons.indexOf(clickedButton) : -1;
                    if (index < 0) return;

                    const mgnlData = this.links[index];
                    if (mgnlData === undefined) return;
                    // TODO refactor after patching ejs dispatch fn
                    const eventInit = {
                        bubbles: true,
                        cancelable: true,
                        composed: true,
                        detail: mgnlData,
                    };

                    const event = new CustomEvent('magnolia-content-click', eventInit);

                    const wasCancelled = !this.dispatchEvent(event);
                    if (wasCancelled) {
                        // forward cancellation to original event
                        e.preventDefault();
                        e.stopPropagation();
                        if (typeof e.stopImmediatePropagation === 'function') {
                            e.stopImmediatePropagation();
                        }
                    }
                },
            },
        };
    }

    template() {
        return html`
            <mb-e-banking-button-bar
                ref="buttonBar"
                .links="${this.links}"
                .subline="${this.content.subline}"
            ></mb-e-banking-button-bar>
        `;
    }
}

defineElement('editable-button-bar', EditableButonBar);
